import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Row, Col, Form, InputGroup, FormControl, Modal } from 'react-bootstrap'
import Select from 'react-select';
import api from '../helper/api';
import { getServerURL } from '../helper/envConfig';
import camera from '../assets/images/svg/camera.svg';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { errorResponse } from '../helper/error';
import Loader from './Loader/Loader';

const AddEditProductDetail = (props) => {

  const serverURL = getServerURL()
  const fileInputRefs = useRef({});
  const engRefs = useRef({});
  const engRef = useRef({});
  const navigate = useNavigate()
  const location = useLocation();
  const groupId = location?.state;
  const editApply = location?.pathname === "/edit-product"

  const [loading, setLoading] = useState(false);

  const [selectedMetals, setSelectedMetals] = useState([]);
  const [selectedShapes, setSelectedShapes] = useState({});
  const [tempSelectedShapes, setTempSelectedShapes] = useState({});
  const [metalData, setMetalData] = useState([])
  const [mainCategoryData, setMainCategoryData] = useState([])
  const [subCategoryData, setSubCategoryData] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [shapeData, setShapeData] = useState([])
  const [states, setStates] = useState({})
  const [statesTemp, setStatesTemp] = useState({})
  const [temp, setTemp] = useState({})
  const [productList, setProductList] = useState([])
  const [selectedImages, setSelectedImages] = useState({});

  const [rowsInfo, setRowsInfo] = useState([]);
  const [rowsGemstone, setRowsGemstone] = useState([]);
  const [rowsLength, setRowsLength] = useState([]);
  const [rowsSize, setRowsSize] = useState([]);
  const [rowsCarat, setRowsCarat] = useState([]);

  const [keyInfo, setKeyInfo] = useState("")
  const [gName, setGName] = useState("")
  const [sName, setSName] = useState("")
  const [cName, setCName] = useState("")
  const [lName, setLName] = useState("")

  const [valueInfo, setValueInfo] = useState("")
  const [gpSelect, setGPSelect] = useState([])
  const [spSelect, setSPSelect] = useState([])
  const [cpSelect, setCPSelect] = useState([])
  const [lpSelect, setLPSelect] = useState([])
  const [engraveStatus, setEngraveStatus] = useState({});
  const [engraveImages, setEngraveImages] = useState({});
  const [oldMetalList, setOldMetalList] = useState([])
  const [removeImageList, setRemoveImageList] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteFun, setDeleteFun] = useState({})

  const deleteImageFun = () => {
    const { metalSlug, imageType, id } = deleteFun
    if (deleteFun?.shapeSlug) {
      handleDeleteShapeImageData(metalSlug, deleteFun?.shapeSlug, imageType)
    } else {
      if (metalSlug && imageType) {
        handleDeleteImageData(metalSlug, imageType, deleteFun?.index);
      }
    }
    if (id) {
      setRemoveImageList((prev) => [...prev, id]);
    }
    setDeleteModal(false)
    setDeleteFun({})
  }

  const editMode = ["model", "women_ring", "earring_ring"];

  // const [selectedInformation, setSelectedInformation] = useState(null);
  const [selectedShape, setSelectedShape] = useState([])
  const [structuredData, setStructuredData] = useState([]);
  const [selectedInformation, setSelectedInformation] = useState([]);

  const [centerDiamondShape, setCenterDiamondShape] = useState([]);
  const [titles, setTitles] = useState({
    "EngagementRingDetails": [{ title: '', keyValues: [], currentKeyInfo: '', currentValueInfo: '' }],
    "Wedding Ring Details": [{ title: '', keyValues: [], currentKeyInfo: '', currentValueInfo: '' }],
    "Jewellery Details": [{ title: '', keyValues: [], currentKeyInfo: '', currentValueInfo: '' }],
  });

  const [informationData, setInformationData] = useState([
    { label: "Engagement Ring Details", value: "EngagementRingDetails" },
    { label: "Wedding Ring Details", value: "Wedding Ring Details" },
    { label: "Jewellery Details", value: "Jewellery Details" },
  ]);

  useEffect(() => {
    getMetal();
    getShape()
    getMainCategory()
  }, []);

  useEffect(() => {
    setStates((prev) => ({ ...prev, metal: convertData(temp) }))
  }, [temp])

  useEffect(() => {
    if (groupId)
      getSingleProduct()
  }, [groupId])

  useEffect(() => {
    if (editApply)
      if (states?.type)
        getMainCategory(states?.type)
    if (states?.type) {
      if (states?.type === "engagement-rings") {
        setInformationData([
          { label: "Engagement Ring Details", value: "EngagementRingDetails" },
          { label: "Wedding Ring Details", value: "Wedding Ring Details" },
        ])
      } else
        if (states?.type === "wedding-rings") {
          setInformationData([
            { label: "Wedding Ring Details", value: "Wedding Ring Details" },
          ])
        } else
          if (states?.type === "jewelry") {
            setInformationData([
              { label: "Jewellery Details", value: "Jewellery Details" },
            ])
          }
    }
  }, [states?.type])

  useEffect(() => {
    if (editApply)
      if (states?.sub_type) {
        getCategory(states?.sub_type)
      }
  }, [states?.sub_type])

  useEffect(() => {
    if (editApply && !hasRun.current) {
      const matchedArray = [];
      if (states?.information?.length) {
        informationData?.forEach(mainItem => {
          const matchingItem = states?.information.find(item => item.hasOwnProperty(mainItem.value));
          if (matchingItem) {
            if (states?.type === "jewelry") {
              matchedArray.push({
                label: mainItem?.label === "Engagement Ring Details" ? "Jewellery Details" : mainItem?.label,
                value: mainItem.value
              });
            } else {
              matchedArray.push({
                label: mainItem.label,
                value: mainItem.value
              });
            }
          }
        });
        setSelectedInformation(matchedArray);

        let combinedDetails = {};

        states?.information?.forEach(item => {
          const mainKey = Object.keys(item) || {};
          if (mainKey?.length) {
            mainKey.forEach(subItem => {
              if (Object.keys(item?.[subItem])?.length) {
                Object.keys(item[subItem]).forEach(v => {
                  if (v !== "Center Diamond") {
                    const keyValues = [];

                    if (item[subItem][v]) {
                      item[subItem][v]?.forEach(x => {
                        if (Object.keys(x)?.length) {
                          Object.keys(x).forEach(k => {
                            keyValues.push({ key: k, value: x[k] });
                          });
                        }
                      });
                    }

                    if (!combinedDetails[subItem]) {
                      combinedDetails[subItem] = [];
                    }

                    combinedDetails[subItem].push({
                      title: v,
                      keyValues: keyValues,
                      currentKeyInfo: "",
                      currentValueInfo: "",
                    });
                  }
                  else {
                    const selectedValues = item[subItem][v]?.map(item => item);

                    const newArray = shapeData?.filter(item =>
                      selectedValues.includes(item.label)
                    );

                    setCenterDiamondShape(newArray)
                  }
                });
              }
            });
          }
        });

        // Update state without duplicating values
        for (const key in combinedDetails) {
          if (combinedDetails.hasOwnProperty(key)) {
            if (titles[key]) {
              // If the key already exists, merge without duplicates
              combinedDetails[key] = [...new Set([...titles[key], ...combinedDetails[key]])];
            }

            // Sort entries to place those with empty keyValues at the end
            const sortedDetails = combinedDetails[key].sort((a, b) => {
              return a.keyValues.length === 0 ? 1 : b.keyValues.length === 0 ? -1 : 0;
            });

            setTitles(prev => ({
              ...prev,
              [key]: sortedDetails,
            }));
          }
        }

        hasRun.current = true;
      }
    }
  }, [editApply, states?.information]);

  useEffect(() => {
    if (selectedInformation) {
      formatData()
    }
  }, [selectedInformation, titles, centerDiamondShape])

  const getSingleProduct = (event) => {
    api.getWithToken(`${serverURL}create-product/product-detail/${groupId}/`)
      .then(async (res) => {
        const { data } = res?.data;
        if (data?.metal_details) {
          let abc = data?.metal_details?.map((item) => ({
            value: item.metal_slug,
            label: item.metal_name,
          }));
          setSelectedMetals(abc)
          setOldMetalList(abc)
        }

        const convertedData = convertProducts(data?.metal_details);
        const newData = { ...data };
        delete newData.metal_details;
        newData.categories = newData?.categories
        newData.sub_type = newData?.sub_type
        newData.category = categoryData?.filter(item => data.categories?.includes(item.value)) || []
        setStates(prev => ({ ...newData, metal: convertedData?.metal }));
        setStatesTemp({ ...newData, metal: convertedData?.metal })

        const result = {};
        data?.metal_details?.forEach(metal => {
          const shapes = metal.shape_details
            .filter(shape => !editMode?.includes(shape?.shape_slug))
            .map(shape => ({
              value: shape.shape_slug,
              label: shape?.shape
            }));
          result[metal.metal_slug] = shapes;

          setSelectedShapes(prev => ({
            ...prev,
            ...result
          }))
          setTempSelectedShapes(prev => ({
            ...prev,
            ...result
          }))
        });
      })
      .catch((e) => {
      });
  };

  const convertProducts = (products) => {

    const metalMap = {};
    const result = {};

    products.forEach(product => {
      const metalId = product.metal_slug;
      const metalName = product.metal_name;
      const isEngrave = product.is_engraving;
      const engrave_image = product?.engraving_image;
      const price = product?.price;
      const discount = product?.discount;
      const product_id = product?.product_id;
      const product_slug = product?.product_slug;

      if (!metalMap[metalId]) {
        metalMap[metalId] = {
          metal_id: metalId,
          metal_name: metalName,
          is_engrave: isEngrave,
          engrave_image: engrave_image,
          product_id: product_id,
          product_slug: product_slug,
          price: price,
          discount: discount,
          metal_photos: [],
          metal_shape: []
        };
      }

      product.shape_details.forEach(shape => {
        // const extraImages = shape.shape_images.filter(image => image.type_name === 'extra').map(image => image.image);
        const extraImages = shape.shape_images
          .filter(image => image.type_name === 'extra')
          .map(image => ({
            image: image.image,
            image_id: image.image_id
          }));

        const otherImages = shape.shape_images.filter(image => image.type_name !== 'extra');

        // Push non-extra images to metal_photos
        otherImages.forEach(image => {
          metalMap[metalId].metal_photos.push({
            key: image.type_name,
            image: image.image,
            image_id: image?.image_id,
          });
        });

        // Handle specific shape_ids
        if (editMode?.includes(shape.shape_slug)) {

          // Merge extra images into one object
          if (extraImages.length > 0) {
            metalMap[metalId].metal_photos.push({
              key: "extra",
              image: extraImages,
            });
          }
        } else {
          // If shape_id is not one of the specific ones, keep it in metal_shape
          if (shape.shape_slug) {
            metalMap[metalId].metal_shape.push({
              shape_id: shape.shape_slug,
              shape_slug: shape?.shape_slug,
              shape: shape.shape,
              image: [
                ...otherImages.map(image => ({ key: image.type_name, image: image.image, image_id: image?.image_id }))
                // {
                //   key: "extra",
                //   image: extraImages
                // }
              ]
            });
          }
        }
      });
    });

    result.metal = Object.values(metalMap)
    return result;
  };

  const getMetal = (event) => {
    api.getWithToken(`${serverURL}product/metal/`)
      .then(async (res) => {
        const { data } = res?.data;
        if (res?.data?.success === true) {
          setMetalData(data?.map(item => ({ value: item.slug, label: item.name })));
        }
      })
      .catch((e) => {
      });
  };

  const getShape = (event) => {
    api.getWithToken(`${serverURL}create-product/shape/`)
      .then(async (res) => {
        const { data } = res?.data;
        if (res?.data?.success === true) {
          setShapeData(data?.map(item => ({ value: item.slug, label: item.name })));
        }
      })
      .catch((e) => {
      });
  };

  const getCategory = (type) => {
    api.getWithToken(`${serverURL}create-product/style/?_i=${type}`)
      .then(async (res) => {
        const { data } = res?.data;

        if (res?.data?.success === true) {
          setCategoryData(res?.data?.data?.map(item => ({ value: item?.slug, label: item?.name })));
        }
        if (editApply) {
          setStates(prev => ({
            ...prev,
            category: res?.data?.data?.map(item => ({ value: item?.slug, label: item?.name }))?.filter(item => states.categories?.includes(item.value)) || []
          }))
        }
      })
      .catch((e) => {
      });
  };

  const getMainCategory = (type) => {
    api.getWithToken(`${serverURL}create-product/category/${Boolean(type) ? `?_i=${type}` : ""}`)
      .then(async (res) => {
        if (type) {
          if (res?.data?.data?.length)
            setSubCategoryData(res?.data?.data);
          else {
            getFilterProductList(type)
            getCategory(type)
          }
        } else
          if (res?.data?.success === true) {
            setMainCategoryData(res?.data?.data);
          }
      })
      .catch((e) => {
      });
  };

  const getFilterProductList = (type, subType) => {
    // create-product/search-filter/?_t=wedding-rings&_st=women
    api.getWithToken(`${serverURL}create-product/search-filter/?_t=${type}${Boolean(subType) ? `&_st=${subType}` : ""}`)
      .then(async (res) => {
        setProductList(res?.data?.data?.map(item => ({ value: item?.id, label: item?.full_name })));
      })
      .catch((e) => {
      });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setStates((prevValues) => ({
        ...prevValues,
        [name]: checked,
      }));
    } else
      setStates((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
  };

  const handleEngClick = () => {
    engRef.current.click();
  };

  const handleImageClick = (metalSlug, shapeSlug, imageType) => {
    fileInputRefs.current[`${metalSlug}-${shapeSlug}-${imageType}`].click();
  };

  const handleImageChange1 = (e, metalSlug, shapeSlug, imageType) => {

    const files = Array.from(e.target.files);
    setTemp(prev => ({
      ...prev,
      [`${metalSlug}-${shapeSlug}`]: {
        ...prev[`${metalSlug}-${shapeSlug}`],
        [imageType]: [
          ...(prev[`${metalSlug}-${shapeSlug}`]?.[imageType] || []),
          ...files
        ],
      },
    }));
    const newImages = files.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(newImages).then(results => {
      setSelectedImages(prev => ({
        ...prev,
        [`${metalSlug}-${shapeSlug}`]: {
          ...prev[`${metalSlug}-${shapeSlug}`],
          [imageType]: [
            ...(prev[`${metalSlug}-${shapeSlug}`]?.[imageType] || []),
            ...results
          ],
        },
      }));
    });
  };

  const handleImageChange = (e, metalSlug, imageType) => {

    if (imageType === "Horizontal Image" || imageType === "Vertical Image") {
      const file = e.target.files[0];
      const type = imageType === "Horizontal Image" ? 'top' : 'side1'

      if (file) {
        setStates(prevState => ({
          ...prevState,
          metal: prevState.metal.map(v => {
            if (v.metal_id === metalSlug) {
              v.metal_photos = v.metal_photos.map((val) => {
                if (val.key === type) {
                  val.image = file
                }
                return val
              })
            }
            return v;
          })
        }));
      }
    }
    if (imageType === "Extra Images") {
      const file = e.target.files;
      if (file) {
        setStates(prevState => ({
          ...prevState,
          metal: prevState.metal.map(v => {
            if (v.metal_id === metalSlug) {
              v.metal_photos = v.metal_photos.map((val) => {
                if (val.key === 'extra') {
                  val.image = [...val.image, ...file]
                }
                return val
              })
            }
            return v;
          })
        }));
      }
    }
  };

  const handleDeleteImageData = (metalSlug, imageType, index) => {
    if (imageType === "Horizontal Image" || imageType === "Vertical Image") {
      const type = imageType === "Horizontal Image" ? 'top' : 'side1'
      setStates(prevState => ({
        ...prevState,
        metal: prevState.metal.map(v => {
          if (v.metal_id === metalSlug) {
            v.metal_photos = v.metal_photos.map((val) => {
              if (val.key === type) {
                val.image = null
              }
              return val
            })
          }
          return v;
        })
      }));
    }
    if (imageType === "Extra Images") {
      setStates(prevState => ({
        ...prevState,
        metal: prevState.metal.map(v => {
          if (v.metal_id === metalSlug) {
            v.metal_photos = v.metal_photos.map((val) => {
              if (val.key === 'extra') {
                val.image = val.image.filter((v, i) => index !== i)
              }
              return val
            })
          }
          return v;
        })
      }));
    }

  };

  const handleShapeImageChange = (e, metalSlug, shapeSlug, imageType) => {

    if (imageType === "Horizontal Image" || imageType === "Vertical Image") {
      const file = e.target.files[0];
      const type = imageType === "Horizontal Image" ? 'top' : 'side1'

      if (file) {
        setStates(prevState => ({
          ...prevState,
          metal: prevState.metal.map(v => {
            if (v.metal_id === metalSlug) {
              v.metal_shape = v.metal_shape.map((val) => {
                if (val.shape_id === shapeSlug) {
                  val.image = val.image.map((elem) => {
                    if (elem.key === type) {
                      elem.image = file
                    }
                    return elem;
                  })
                }
                return val
              })
            }
            return v;
          })
        }));
      }
    }
  };

  const handleDeleteShapeImageData = (metalSlug, shapeSlug, imageType) => {
    if (imageType === "Horizontal Image" || imageType === "Vertical Image") {
      const type = imageType === "Horizontal Image" ? 'top' : 'side1'

      setStates(prevState => ({
        ...prevState,
        metal: prevState.metal.map(v => {
          if (v.metal_id === metalSlug) {
            v.metal_shape = v.metal_shape.map((val) => {
              if (val.shape_id === shapeSlug) {
                val.image = val.image.map((elem) => {
                  if (elem.key === type) {
                    elem.image = null
                  }
                  return elem;
                })
              }
              return val
            })
          }
          return v;
        })
      }));
    }

  };

  const handleEngraveImageChange = async (e, metalSlug, shapeSlug, imageType) => {

    const file = e.target.files[0];

    if (file) {
      setStates(prevState => ({
        ...prevState,
        metal: prevState.metal.map(v => {
          if (v.metal_id === metalSlug) {
            return {
              ...v,
              engrave_image: file
            };
          }
          return v;
        })
      }));
    }

  };

  const handleShapeChange = (selectedOptions, metalSlug) => {
    setSelectedShapes(prev => ({
      ...prev,
      [metalSlug]: selectedOptions
    }));
    setStates(prevState => ({
      ...prevState,
      metal: prevState.metal.map(v => {
        if (v.metal_id === metalSlug) {
          v.metal_photos = v?.metal_photos?.map((val) => {
            if (val.key === 'top' || val.key === 'side1') {
              val.image = null
            }
            return val
          })

          let temp = v.metal_shape
          temp = v.metal_shape?.filter((v) => selectedOptions.some((val) => val.value === v.shape_id))
          const add = selectedOptions.find((va) => !v.metal_shape?.some((val) => val.shape_id === va.value))?.value
          if (add) {
            temp.push({ shape_id: add, image: [{ key: 'top', image: null }, { key: 'side1', image: null }] })
          }

          v.metal_shape = temp

        }
        return v;
      })
    }));
  };

  // const handleCategoryChange = (selectCategory) => {
  //   setStates(prev => ({
  //     ...prev,
  //     category: selectCategory
  //   }));
  // };

  const handleCategoryChange = (selectCategory) => {
    setStates(prev => ({
      ...prev,
      category: selectCategory
    }));
  };

  const handleMetalChange = (selectCategory) => {
    setSelectedMetals(selectCategory)

    let temp = states.metal
    temp = states.metal.filter((v) => selectCategory.some((val) => val.value === v.metal_id))

    const add = selectCategory.find((v) => !states.metal.some((val) => val.metal_id === v.value))?.value
    const name = selectCategory.find((v) => !states.metal.some((val) => val.metal_id === v.value))?.label
    if (add) {
      temp.push({ metal_id: add, metal_name: name, is_engrave: false, metal_photos: [{ key: 'top', image: null }, { key: 'side1', image: null }, { key: 'extra', image: [] }], metal_shape: [] })
    }

    setStates(prev => ({
      ...prev,
      metal: temp
    }));
  };

  const renderImageUpload = (metalSlug, shapeSlug, imageType, label) => (
    <div key={`${metalSlug}-${shapeSlug}-${imageType}`}>
      <Form.Label column>{label}</Form.Label>
      <div className='d-flex align-items-center gap-3 flex-wrap'>
        <div className="position-relative profile-image" id="profile_image">
          <div className="d-flex flex-wrap">
            {Boolean(imageType !== "extra") && (selectedImages[`${metalSlug}-${shapeSlug}`]?.[imageType] || []).map((image, index) =>
              <img
                key={index}
                src={image}
                onClick={() => handleImageClick(metalSlug, shapeSlug, imageType)}
                className={`cursor-pointer upload-image`}
                alt={`uploaded-${index}`}
                style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
              />
            )}
          </div>
          <input
            type="file"
            accept=".jpg, .jpeg, .png, webm, .webp"
            multiple={imageType === "extra" ? true : false}
            style={{ display: "none" }}
            ref={el => fileInputRefs.current[`${metalSlug}-${shapeSlug}-${imageType}`] = el}
            onChange={(e) => handleImageChange(e, metalSlug, imageType)}
          />
          <img
            src={camera}
            onClick={() => handleImageClick(metalSlug, shapeSlug, imageType)}
            className="cursor-pointer position-absolute top-50 start-50 translate-middle"
            width={30}
            height={30} />
        </div>

        {Boolean(imageType === "extra") && (selectedImages[`${metalSlug}-${shapeSlug}`]?.[imageType] || []).map((image, index) =>
          <img
            key={index}
            src={image}
            onClick={() => handleImageClick(metalSlug, shapeSlug, imageType)}
            className={`cursor-pointer upload-image border rounded-3`}
            alt={`uploaded-${index}`}
            style={{ width: '100px', height: '100px', objectFit: 'contain', }}
          />
        )}
      </div>
    </div>
  );

  const handleAddRowInfo1 = () => {
    if (keyInfo !== "" && valueInfo !== "") {
      const currentInfo = Array.isArray(states?.information) ? states.information : [];
      const isDuplicate = states.information?.some(row => row.key === keyInfo && row.value === valueInfo);
      if (!isDuplicate) {
        setStates({ ...states, information: [...currentInfo, { key: keyInfo, value: valueInfo }] });
        setKeyInfo("");
        setValueInfo("");
      } else {
        toast.error("Same value not added!");
      }
    } else {
      toast.error("Name & Product name both are required");
    }
  };

  const handleDeleteRowInfo1 = (index) => {
    setStates(st => ({
      ...st,
      information: st.information.filter((_, i) => i !== index)
    }));
  };

  const gemstoneIndexChange = (currentIndex, targetIndex) => {
    let updatedRows = [...rowsGemstone];
    if (currentIndex < 0 || currentIndex >= updatedRows.length || targetIndex < 0 || targetIndex >= updatedRows.length) {
      toast.error("Invalid index number")
    }
    updatedRows.splice(targetIndex, 0, updatedRows.splice(currentIndex, 1)[0]);
    updatedRows = updatedRows.map((v, i) => {
      v.index = i + 1
      return v
    })
    setRowsGemstone(updatedRows);
    setStates({ ...states, gemstone: updatedRows });
  };

  const caratIndexChange = (currentIndex, targetIndex) => {
    let updatedRows = [...rowsCarat];
    if (currentIndex < 0 || currentIndex >= updatedRows.length || targetIndex < 0 || targetIndex >= updatedRows.length) {
      toast.error("Invalid index number")
    }
    updatedRows.splice(targetIndex, 0, updatedRows.splice(currentIndex, 1)[0]);
    updatedRows = updatedRows.map((v, i) => {
      v.index = i + 1
      return v
    })
    setRowsCarat(updatedRows);
    setStates({ ...states, carat: updatedRows });
  };

  const sizeIndexChange = (currentIndex, targetIndex) => {
    let updatedRows = [...rowsSize];
    if (currentIndex < 0 || currentIndex >= updatedRows.length || targetIndex < 0 || targetIndex >= updatedRows.length) {
      toast.error("Invalid index number")
    }
    updatedRows.splice(targetIndex, 0, updatedRows.splice(currentIndex, 1)[0]);
    updatedRows = updatedRows.map((v, i) => {
      v.index = i + 1
      return v
    })
    setRowsSize(updatedRows);
    setStates({ ...states, size: updatedRows });
  };

  const lengthIndexChange = (currentIndex, targetIndex) => {
    let updatedRows = [...rowsLength];
    if (currentIndex < 0 || currentIndex >= updatedRows.length || targetIndex < 0 || targetIndex >= updatedRows.length) {
      toast.error("Invalid index number")
    }
    updatedRows.splice(targetIndex, 0, updatedRows.splice(currentIndex, 1)[0]);
    updatedRows = updatedRows.map((v, i) => {
      v.index = i + 1
      return v
    })
    setRowsLength(updatedRows);
    setStates({ ...states, length: updatedRows });
  };

  const handleAddRowGemstone = () => {
    if (gName !== "" && gpSelect && typeof gpSelect === 'object' && 'label' in gpSelect) {
      const currentGemstones = Array.isArray(states?.gemstone) ? states.gemstone : [];
      const isDuplicate = rowsGemstone.some(row => row.name === gName && row.product === gpSelect.label);
      if (!isDuplicate) {
        setRowsGemstone([...rowsGemstone, { index: currentGemstones?.length + 1 || 1, name: gName, product: gpSelect.label }]);
        setStates({ ...states, gemstone: [...currentGemstones, { index: currentGemstones?.length + 1 || 1, name: gName, product: gpSelect?.value }] });
        setGName("");
        setGPSelect({});
      } else {
        toast.error("Same value not added!");
      }
    } else {
      toast.error("Name & Product name both are required");
    }
  };

  const handleDeleteGemstone = (index) => {
    const newRows = rowsGemstone.filter((_, idx) => idx !== index);
    const correctedRows = newRows.map((row, idx) => ({ ...row, index: idx + 1 }));
    setRowsGemstone(correctedRows);
    setStates({
      ...states,
      gemstone: correctedRows,
    });
  };

  const handleAddRowCarat = () => {
    if (cName !== "" && cpSelect && typeof cpSelect === 'object' && 'label' in cpSelect) {
      const currentCarat = Array.isArray(states?.carat) ? states.carat : [];
      const isDuplicate = rowsCarat?.some(row => row.name === cName && row.product === cpSelect.label);
      if (!isDuplicate) {
        setRowsCarat([...rowsCarat, { index: currentCarat?.length + 1 || 1, name: cName, product: cpSelect.label }]);
        setStates({ ...states, carat: [...currentCarat, { index: currentCarat?.length + 1 || 1, name: cName, product: cpSelect?.value }] });
        setCName("");
        setCPSelect({});
      } else {
        toast.error("Same value not added!");
      }
    } else {
      toast.error("Name & Product name both are required");
    }
  };

  const handleDeleteCarat = (index) => {
    const newRows = rowsCarat.filter((_, idx) => idx !== index);
    const correctedRows = newRows.map((row, idx) => ({ ...row, index: idx + 1 }));
    setRowsCarat(correctedRows);
    setStates({
      ...states,
      carat: correctedRows,
    });
  };

  const handleAddRowLength = () => {
    if (lName !== "" && lpSelect && typeof lpSelect === 'object' && 'label' in lpSelect) {
      const currentLength = Array.isArray(states?.length) ? states.length : [];
      const isDuplicate = rowsLength.some(row => row.name === lName && row.product === lpSelect.label);
      if (!isDuplicate) {
        setRowsLength([...rowsLength, { index: currentLength?.length + 1 || 1, name: lName, product: lpSelect.label }]);
        setStates({ ...states, length: [...currentLength, { index: currentLength?.length + 1 || 1, name: lName, product: lpSelect?.value }] });
        setLName("");
        setLPSelect({});
      } else {
        toast.error("Same value not added!");
      }
    } else {
      toast.error("Name & Product name both are required");
    }
  };

  const handleDeleteLength = (index) => {
    const newRows = rowsLength.filter((_, idx) => idx !== index);
    const correctedRows = newRows.map((row, idx) => ({ ...row, index: idx + 1 }));
    setRowsLength(correctedRows);
    setStates({
      ...states,
      length: correctedRows,
    });
  };

  const handleAddRowSize = () => {
    if (sName !== "" && spSelect && typeof spSelect === 'object' && 'label' in spSelect) {
      const currentSize = Array.isArray(states?.size) ? states.size : [];
      const isDuplicate = rowsSize?.some(row => row.name === sName && row.product === spSelect.label);
      if (!isDuplicate) {
        setRowsSize([...rowsSize, { index: currentSize?.length + 1 || 1, name: sName, product: spSelect.label }]);
        setStates({ ...states, size: [...currentSize, { index: currentSize?.length + 1 || 1, name: sName, product: spSelect?.value }] });
        setSName("");
        setSPSelect({});
      } else {
        toast.error("Same value not added!");
      }
    } else {
      toast.error("Name & Product name both are required");
    }
  };

  const handleDeleteSize = (index) => {
    const newRows = rowsSize.filter((_, idx) => idx !== index);
    const correctedRows = newRows.map((row, idx) => ({ ...row, index: idx + 1 }));
    setRowsSize(correctedRows);
    setStates({
      ...states,
      size: correctedRows,
    });
  };

  const convertData = (data) => {
    const result = [];

    for (const [key, value] of Object.entries(data)) {

      const [metalId, shapeId] = key.split('-');
      let metal = result.find((item) => item.metal_id === metalId);

      if (!metal) {
        metal = {
          metal_id: metalId,
          metal_photos: [],
          metal_shape: [],
        };
        result.push(metal);
      }

      if (!shapeId) {
        for (const [imgKey, imgValue] of Object.entries(value)) {
          metal.metal_photos.push({
            key: imgKey,
            image: Array.from(imgValue),
          });
        }
      } else {
        let shape = metal.metal_shape.find((item) => item.shape_id === shapeId);

        if (!shape) {
          shape = {
            shape_id: shapeId,
            image: [],
          };
          metal.metal_shape.push(shape);
        }

        for (const [imgKey, imgValue] of Object.entries(value)) {
          shape.image.push({
            key: imgKey,
            image: Array.from(imgValue),
          });
        }
      }
    }

    return result;
  };

  const handleEngImage = (e) => {

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      setStates({
        ...states,
        engrave_image: file,
      });
    }

  };

  const appendObjectToFormData = (obj, formData, prefix = "") => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const propName = prefix ? `${prefix}[${key}]` : key;

        if (Array.isArray(obj[key])) {
          obj[key].forEach((item, index) => {
            const arrayPropName = `${propName}[${index}]`;
            if (typeof item === "object" && !(item instanceof File) && !(item instanceof Blob)) {
              appendObjectToFormData(item, formData, arrayPropName);
            } else {
              formData.append(arrayPropName, item);
            }
          });
        } else if (typeof obj[key] === "object" && !(obj[key] instanceof File) && !(obj[key] instanceof Blob)) {
          appendObjectToFormData(obj[key], formData, propName);
        } else {
          formData.append(propName, obj[key]);
        }
      }
    }
  };

  const handleSubmit = (event) => {

    if (!states?.display_name?.trim()) {
      toast.error('Please enter display name');
      return
    }

    if (states?.display_name?.trim()?.length < 3 || states?.display_name?.trim()?.length > 50) {
      toast.error("Display name must be between 3 and 50 characters long.");
      return
    }

    if (!states?.full_name?.trim()) {
      toast.error('Please enter product full name');
      return
    }

    if (states?.full_name?.trim()?.length < 3 || states?.full_name?.trim()?.length > 255) {
      toast.error("Product full name must be between 3 and 255 characters long.");
      return
    }

    if (!states?.description?.trim()) {
      toast.error('Please enter description');
      return
    }

    if (states?.description?.trim()?.length < 3 || states?.description?.trim()?.length > 500) {
      toast.error("Description must be between 3 and 500 characters long.");
      return
    }

    if (!states?.type?.trim()) {
      toast.error('Please select product type');
      return
    }

    if (subCategoryData?.length > 0 && !states?.sub_type) {
      toast.error('Please select product sub type');
      return
    }

    if (categoryData?.length > 0 && !(states?.category?.length > 0)) {
      toast.error('Please select product category');
      return
    }

    if (!(selectedMetals?.length > 0)) {
      toast.error('Please select product metal');
      return
    }

    const metalIds = new Set(states?.metal.map(item => item.metal_id));
    const unmatchedValues = [];

    for (const item of oldMetalList) {
      if (!metalIds.has(item.value)) {
        unmatchedValues.push(item.value);
      }
    }

    let removedMetalSlugs = [];
    const removedShapeItems = {};
    if (editApply) {
      removedMetalSlugs = statesTemp?.metal?.filter(m => unmatchedValues?.includes(m?.metal_id))
        .map(m => m?.product_id);

      for (const key in tempSelectedShapes) {
        if (Array.isArray(tempSelectedShapes[key]) && Array.isArray(selectedShapes[key])) {
          const oldItems = tempSelectedShapes[key];
          const newItems = selectedShapes[key];

          // Find removed items
          const removed = oldItems.filter(oldItem =>
            !newItems.some(newItem => newItem.value === oldItem.value)
          )?.map((item) => item?.value);

          // Initialize removedShapeItems[key] if it doesn't exist
          if (!removedShapeItems[key]) {
            removedShapeItems[key] = [];
          }

          removed.forEach(removedItem => {
            if (!removedShapeItems[key].includes(removedItem)) {
              removedShapeItems[key].push(removedItem);
            }
          });
        }
      }
    }

    let flag = false;
    if (states?.metal?.length > 0) {
      for (const elem of states?.metal) {

        if (elem?.is_engrave && !elem?.engrave_image) {
          toast.error(`Please upload engrave image for ${elem.metal_id}`);
          return
        }
        if (elem?.metal_shape.length === 0) {
          for (const val of elem.metal_photos) {
            if ((val.key === 'top' || val.key === 'side1') && !val.image) {
              toast.error(`Please upload ${val.key === 'top' ? 'horizontal' : 'vertical'} image for ${elem.metal_id} metal`);
              flag = true
              return
            }
          }
        } else {
          for (const v of elem.metal_shape) {
            for (const va of v.image) {
              if ((va.key === 'top' || va.key === 'side1') && !va.image) {
                toast.error(`Please upload ${va.key === 'top' ? 'horizontal' : 'vertical'} image for ${v.shape_id} shape in ${elem.metal_id} metal`);
                flag = true
                return
              }
            }
          }
        }
        if (flag) {
          return
        }
      }
    }
    if (flag) {
      return
    }

    const formData = new FormData();

    if (states?.group_id)
      formData.append('group_id', states.group_id);
    formData.append('display_name', states.display_name.trim());
    formData.append('full_name', states.full_name.trim());
    formData.append('description', states.description.trim());
    formData.append('type', states.type);
    states?.sub_type && formData.append('sub_type', states.sub_type);

    if (states?.category?.length > 0) {
      const temp = states.category.map((v) => v.value)
      formData.append('category', JSON.stringify(temp));
    }
    if (removeImageList?.length) {
      formData.append('removeImageList', JSON.stringify(removeImageList));
    }

    if (Object.keys(states?.information)?.length) {
      formData.append('information', JSON.stringify(states.information));
      // Object.keys(states?.information)?.forEach((mainKey) => {
      //   Object.keys(states?.information[mainKey])?.forEach((subKey) => {
      //     states?.information[mainKey][subKey]?.forEach((item, index) => {
      //       formData.append(`information[${mainKey}][${subKey}][${index}][key]`, item.key);
      //       formData.append(`information[${mainKey}][${subKey}][${index}][value]`, item.value);
      //     });
      //   });
      // });
    }



    formData.append('is_diamond', states?.is_diamond ? true : false);
    formData.append('is_activate', states?.is_activate ? true : false);

    if (editApply) {
      formData.append('removeMetalList', JSON.stringify(removedMetalSlugs));
      // removedMetalSlugs?.forEach((elem, index) => {
      //   formData.append(`removeMetalList[${index}]`, JSON.stringify(elem));
      // })
      // for (const key in removedShapeItems) {
      //   formData.append(`removedShapeItems[${key}]`, JSON.stringify(removedShapeItems[key]));
      // }
    }

    if (states?.metal?.length > 0) {
      states?.metal?.forEach((elem, index) => {
        formData.append(`metal[${index}][metal_id]`, elem.metal_id);
        if (elem.product_id)
          formData.append(`metal[${index}][product_id]`, elem.product_id);

        for (const key in removedShapeItems) {
          if (elem?.metal_id === key) {
            formData.append(`metal[${index}][removedShapeItems]`, JSON.stringify(removedShapeItems[key]));
          }
        }

        if (elem?.is_engrave) {
          formData.append(`metal[${index}][is_engrave]`, elem.is_engrave);
          formData.append(`metal[${index}][engrave_image]`, elem.engrave_image);
        }

        if (elem?.price) {
          formData.append(`metal[${index}][price]`, elem.price);
        }
        if (elem?.discount) {
          formData.append(`metal[${index}][discount]`, elem.discount);
        }

        let count = 0;

        elem?.metal_photos?.length > 0 && elem.metal_photos.forEach((val, i) => {
          if (val?.key === 'extra' && val?.image?.length > 0) {

            formData.append(`metal[${index}][metal_photos][${count}][key]`, val?.key);
            val?.image?.forEach((e, ind) => {
              if (e?.image || e?.image_id) {
                formData.append(`metal[${index}][metal_photos][${count}][image]`, e?.image);
                if (Boolean(e?.image_id))
                  formData.append(`metal[${index}][metal_photos][${count}][image_id]`, e?.image_id);
              } else
                formData.append(`metal[${index}][metal_photos][${count}][image]`, e);
            })
            count++
          }
          if ((val?.key === 'top' || val?.key === 'side1') && val.image) {
            formData.append(`metal[${index}][metal_photos][${count}][key]`, val?.key);
            formData.append(`metal[${index}][metal_photos][${count}][image]`, val.image);
            if (Boolean(val?.image_id))
              formData.append(`metal[${index}][metal_photos][${count}][image_id]`, val.image_id);
            count++
          }
        })

        elem?.metal_shape?.length > 0 && elem.metal_shape.forEach((val, i) => {

          formData.append(`metal[${index}][metal_shape][${i}][shape_id]`, val?.shape_id);

          val.image.forEach((e, ind) => {
            if (e?.key === "extra" && e?.image?.length === 0) {

            } else {
              formData.append(`metal[${index}][metal_shape][${i}][image][${ind}][key]`, e?.key);
              formData.append(`metal[${index}][metal_shape][${i}][image][${ind}][image]`, e?.image);
              if (Boolean(e?.image_id))
                formData.append(`metal[${index}][metal_shape][${i}][image][${ind}][image_id]`, e?.image_id);
            }
          })
        })

      })
    }

    setLoading(true)
    const type = location?.pathname === "/add-product" ? "postWithToken" : "putWithToken";
    // event.preventDefault();
    api[type](`${serverURL}create-product/${editApply ? "update-product/" : ""}`, formData)
      .then(async (res) => {
        setLoading(false)
        // setStates({})
        // setLoading(false);
        if (res?.data?.success === true) {
          toast.success(res?.data?.message);
          navigate("/product-details")
        } else if (res?.data?.success === false) {
          if (typeof res?.data?.message === "string")
            toast.error(res?.data?.message);
        }
      })
      .catch((e) => {
        setLoading(false)
        errorResponse(e);
      });

    // setValidated(false);
  };

  // const handleEngraveStatusChange = (metalSlug, value) => {
  //   setStates(prev => ({
  //     ...prev,metal:
  //     {...prev?.metal, is_engrave : value}
  //   }));
  // };

  const handlePrice = (metalSlug, value) => {
    setStates(prev => {
      const updatedMetalArray = prev.metal.map(metal => {
        if (metal.metal_id === metalSlug) {
          return {
            ...metal,
            price: value,
          };
        }
        return metal;
      });

      const metalExists = prev.metal.some(metal => metal.metal_id === metalSlug);
      if (!metalExists) {
        updatedMetalArray.push({
          metal_id: metalSlug,
          price: value,
        });
      }

      return {
        ...prev,
        metal: updatedMetalArray
      };
    });
  };

  const handleDiscount = (metalSlug, value) => {
    setStates(prev => {
      const updatedMetalArray = prev.metal.map(metal => {
        if (metal.metal_id === metalSlug) {
          return {
            ...metal,
            discount: value,
          };
        }
        return metal;
      });

      const metalExists = prev.metal.some(metal => metal.metal_id === metalSlug);
      if (!metalExists) {
        updatedMetalArray.push({
          metal_id: metalSlug,
          discount: value,
        });
      }

      return {
        ...prev,
        metal: updatedMetalArray
      };
    });
  };

  const handleEngraveStatusChange = (metalSlug, value) => {
    setStates(prev => {
      const updatedMetalArray = prev.metal.map(metal => {
        if (metal.metal_id === metalSlug) {
          return {
            ...metal,
            is_engrave: value,
            engrave_image: value === false ? null : metal.engrave_image
          };
        }
        return metal;
      });

      const metalExists = prev.metal.some(metal => metal.metal_id === metalSlug);
      if (!metalExists) {
        updatedMetalArray.push({
          metal_id: metalSlug,
          is_engrave: value,
          // engrave_image: value === false ? null : metal.engrave_image
        });
      }

      return {
        ...prev,
        metal: updatedMetalArray
      };
    });
  };

  const renderEngraveImageInput = (metalSlug, imageType, image) => (
    <Form.Group className="mb-3 d-flex align-items-center" as={Row} controlId="formHorizontalCheck">
      <Form.Label as="legend" column lg={1} className='mb-0'>
        Engrave Image
      </Form.Label>
      <div className="position-relative profile-image" id="profile_image">
        <div className="d-flex">
          {/* {(selectedImages[`${metalSlug}-`]?.[imageType] || []).map((image, index) => */}
          {image && <img
            // key={index}
            src={image.size ? URL.createObjectURL(image) : image}
            onClick={() => handleClick(imageType + "-" + metalSlug)}
            className={`cursor-pointer upload-image`}
            alt={`uploaded`}
            style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
          />}
          {/* )} */}
        </div>
        <input
          type="file"
          accept=".jpg, .jpeg, .png, webm, .webp"
          name="image"
          style={{ display: "none" }}
          // ref={el => engRefs.current[`${metalSlug}-engrave`] = el}
          ref={el => fileInputRefs.current[`${imageType}-${metalSlug}`] = el}
          // onChange={(e) => handleEngraveImageChange(e, metalSlug)}
          onChange={(e) => handleEngraveImageChange(e, metalSlug, "", imageType)}
        />
        <img
          src={camera}
          className="cursor-pointer position-absolute top-50 start-50 translate-middle"
          width={30}
          height={30}
          // onClick={() => engRefs.current[`${metalSlug}-engrave`]?.click()}
          onClick={() => handleClick(imageType + "-" + metalSlug)}
        />
      </div>
    </Form.Group>
  );

  const handleClick = (tet) => {
    fileInputRefs.current[`${tet}`].click();
  };

  const handleProductType = (e) => {
    setStates((prevValues) => ({
      ...prevValues,
      type: e?.target?.value,
      sub_type: '',
      category: []
    }));
    setSubCategoryData([]);
    setCategoryData([]);
    setSelectedInformation([])
    if (e?.target?.value === "engagement-rings") {
      getCategory(e?.target?.value);
    } else
      getMainCategory(e?.target?.value)
  };

  const handleProductSubType = (e) => {
    setStates((prevValues) => ({
      ...prevValues,
      sub_type: e?.target?.value,
      category: []
    }));
    setCategoryData([]);
    getCategory(e?.target?.value);
    getFilterProductList(states?.type, e?.target?.value)
  };
  const hasRun = useRef(false);

  // useEffect(() => {
  //   if (editApply && !hasRun.current) {
  //     const matchedArray = [];
  //     if (states?.information?.length) {
  //       informationData?.forEach(mainItem => {
  //         const matchingItem = states?.information.find(item => item.hasOwnProperty(mainItem.value));
  //         if (matchingItem) {
  //           matchedArray.push({
  //             label: mainItem.label,
  //             value: mainItem.value
  //           });
  //         }
  //       });
  //       setSelectedInformation(matchedArray);

  //       let abc = [];

  //       states?.information?.forEach(item => {
  //         const mainKey = Object.keys(item) || {};
  //         if (mainKey?.length) {
  //           mainKey.forEach(subItem => {
  //             if (Object.keys(item?.[subItem])?.length) {
  //               Object.keys(item[subItem]).forEach(v => {
  //                 if (v !== "Center Diamond") {
  //                   const keyValues = [];

  //                   if (item[subItem][v]) {
  //                     item[subItem][v]?.forEach(x => {
  //                       if (Object.keys(x)?.length) {
  //                         Object.keys(x).forEach(k => {
  //                           keyValues.push({ key: k, value: x[k] });
  //                         });
  //                       }
  //                     });
  //                   }

  //                   abc.push({
  //                     title: v,
  //                     keyValues: keyValues,
  //                     currentKeyInfo: "",
  //                     currentValueInfo: "",
  //                   });
  //                 }
  //               });
  //             }
  //           });
  //           // Only set titles if abc has items
  //           if (abc.length > 0) {
  //             setTitles(prev => ({
  //               ...prev,
  //               [mainKey]: abc,
  //             }));
  //           }
  //         }
  //       });



  //       hasRun.current = true;
  //     }
  //   }
  // }, [editApply, states?.information]);

  // useEffect(() => {
  //   if (editApply && !hasRun.current) {
  //     const matchedArray = [];
  //     if (states?.information?.length) {
  //       informationData?.forEach(mainItem => {
  //         const matchingItem = states?.information.find(item => item.hasOwnProperty(mainItem.value));
  //         if (matchingItem) {
  //           matchedArray.push({
  //             label: mainItem.label,
  //             value: mainItem.value
  //           });
  //         }
  //       });
  //       setSelectedInformation(matchedArray);

  //       let combinedDetails = {};

  //       states?.information?.forEach(item => {
  //         const mainKey = Object.keys(item) || {};
  //         if (mainKey?.length) {
  //           mainKey.forEach(subItem => {
  //             if (Object.keys(item?.[subItem])?.length) {
  //               Object.keys(item[subItem]).forEach(v => {
  //                 if (v !== "Center Diamond") {
  //                   const keyValues = [];

  //                   if (item[subItem][v]) {
  //                     item[subItem][v]?.forEach(x => {
  //                       if (Object.keys(x)?.length) {
  //                         Object.keys(x).forEach(k => {
  //                           keyValues.push({ key: k, value: x[k] });
  //                         });
  //                       }
  //                     });
  //                   }

  //                   if (!combinedDetails[subItem]) {
  //                     combinedDetails[subItem] = [];
  //                   }

  //                   combinedDetails[subItem].push({
  //                     title: v,
  //                     keyValues: keyValues,
  //                     currentKeyInfo: "",
  //                     currentValueInfo: "",
  //                   });
  //                 }
  //               });
  //             }
  //           });
  //         }
  //       });

  //       // Update state without duplicating values
  //       for (const key in combinedDetails) {
  //         if (combinedDetails.hasOwnProperty(key)) {
  //           if (titles[key]) {
  //             // If the key already exists, merge without duplicates
  //             combinedDetails[key] = [...new Set([...titles[key], ...combinedDetails[key]])];
  //           }
  //           setTitles(prev => ({
  //             ...prev,
  //             [key]: combinedDetails[key],
  //           }));
  //         }
  //       }

  //       hasRun.current = true;
  //     }
  //   }
  // }, [editApply, states?.information]);

  const formatData = () => {
    const data = {
      information: []
    };

    selectedInformation.forEach(info => {
      const infoEntry = {};
      const formattedInfo = {};

      titles[info.value]?.forEach(title => {
        const keyValueArray = title.keyValues.filter(kv => kv.key && kv.value);
        if (keyValueArray.length > 0) {
          formattedInfo[title.title] = keyValueArray.map(kv => ({
            [kv.key]: kv.value
          }));
        }
      });

      if (info.value === "EngagementRingDetails" && centerDiamondShape.length > 0) {
        formattedInfo['Center Diamond'] = centerDiamondShape.map(shape => shape.label);
      }

      const entryKey = info.value === "Jewellery Details" ? "EngagementRingDetails" : info.label === "Engagement Ring Details" ? "EngagementRingDetails" : info?.label

      infoEntry[entryKey] = formattedInfo;
      data.information.push(infoEntry);
    });

    setStates(prev => ({
      ...prev,
      information: data.information
    }));

    setStructuredData(data);
  };

  const handleAddRowInfo = (infoLabel, titleIndex) => {
    const { title, keyValues, currentKeyInfo, currentValueInfo } = titles[infoLabel][titleIndex];

    if (!title) {
      toast.error('Please enter a title before adding key-value pairs.');
      return;
    }

    if (currentKeyInfo && currentValueInfo) {
      const isDuplicate = keyValues.some(row => row.key === currentKeyInfo && row.value === currentValueInfo);
      if (!isDuplicate) {
        setTitles(prevTitles => {
          const newTitles = { ...prevTitles };
          newTitles[infoLabel][titleIndex].keyValues = [...keyValues, { key: currentKeyInfo, value: currentValueInfo }];
          newTitles[infoLabel][titleIndex].currentKeyInfo = ''; // Reset current key input for this title
          newTitles[infoLabel][titleIndex].currentValueInfo = ''; // Reset current value input for this title
          return newTitles;
        });
      } else {
        toast.error('Duplicate key-value pair not added!');
      }
    } else {
      toast.error('Key & Value are required.');
    }
  };

  const handleDeleteRowInfo = (infoLabel, titleIndex, keyValueIndex) => {
    setTitles(prevTitles => {
      const newTitles = { ...prevTitles };
      newTitles[infoLabel][titleIndex].keyValues.splice(keyValueIndex, 1);
      return newTitles;
    });
  };

  const handleDeleteTitle = (infoLabel, titleIndex) => {
    setTitles(prevTitles => {
      const newTitles = { ...prevTitles };
      newTitles[infoLabel].splice(titleIndex, 1);
      return newTitles;
    });
  };

  const handleTitleChange = (infoLabel, titleIndex, e) => {
    setTitles(prevTitles => {
      const newTitles = [...prevTitles[infoLabel]];
      newTitles[titleIndex].title = e.target.value;
      return { ...prevTitles, [infoLabel]: newTitles };
    });
  };

  const handleAddTitle = (infoLabel) => {
    const lastTitle = titles[infoLabel][titles[infoLabel].length - 1];
    if (!lastTitle.title || !lastTitle.keyValues.length) {
      toast.error('Please enter a title and at least one key-value pair before adding a new title.');
      return;
    }

    setTitles(prevTitles => ({
      ...prevTitles,
      [infoLabel]: [...prevTitles[infoLabel], { title: '', keyValues: [], currentKeyInfo: '', currentValueInfo: '' }],
    }));
  };

  const handleKeyChange = (infoLabel, titleIndex, value) => {
    setTitles(prevTitles => {
      const newTitles = [...prevTitles[infoLabel]];
      newTitles[titleIndex].currentKeyInfo = value; // Store current key input
      return { ...prevTitles, [infoLabel]: newTitles };
    });
  };

  const handleValueChange = (infoLabel, titleIndex, value) => {
    setTitles(prevTitles => {
      const newTitles = [...prevTitles[infoLabel]];
      newTitles[titleIndex].currentValueInfo = value; // Store current value input
      return { ...prevTitles, [infoLabel]: newTitles };
    });
  };

  return (
    <>
      {/* 
      <Example /> */}
      {Boolean(loading) && <Loader loading={loading} />}

      <Card className="user-list">
        <Card.Header>
          <div className='d-flex justify-content-between align-items-center'>
            <Card.Title as="h4">{props?.title || ""}</Card.Title>
            <div className='d-flex align-items-center'>
              <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
              </header>
            </div>
          </div>
        </Card.Header>

        <Card.Body>
          <Form>

            <Form.Group className="mb-3" as={Row} controlId="formHorizontalName">
              <Form.Label column sm={3}>
                Display Name
              </Form.Label>
              <Form.Control type="text" placeholder="Enter display name" value={states.display_name} name="display_name" onChange={handleChange} />
            </Form.Group>

            <Form.Group className="mb-3" as={Row} controlId="formHorizontalName">
              <Form.Label column sm={3}>
                Full Name
              </Form.Label>
              <Form.Control type="text" placeholder="Enter full name" name="full_name" value={states.full_name} onChange={handleChange} />
            </Form.Group>

            <Form.Group className="mb-1 align-items-end" as={Row} controlId="formHorizontalName">
              <Form.Label column sm={3}>
                Description
              </Form.Label>
              <Form.Control as="textarea" rows="3" placeholder="Enter product description" value={states.description} name="description" onChange={handleChange} />
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalName">
              <Col lg={6}>
                <Form.Label column>
                  Select Type
                </Form.Label>
                <InputGroup className="mb-3">
                  {/* <FormControl as="select" aria-describedby="custom-addons1" className="custom-select" value={states?.category_slug || states?.category || ""} name='category' onChange={handleChange}> */}
                  <FormControl as="select" aria-describedby="custom-addons1" className="custom-select" value={states?.type || ""} name='type'
                    onChange={handleProductType}>
                    <option value={""} disabled>Choose type</option>
                    {Boolean(mainCategoryData?.length) &&
                      mainCategoryData?.map((item, index) => <option value={item?.slug} className='text-capitalize'>{item?.name}</option>)}
                  </FormControl>
                </InputGroup>
              </Col>

              {Boolean(subCategoryData?.length) &&
                <Col lg={6}>
                  <Form.Label column>
                    Sub Type
                  </Form.Label>
                  <InputGroup className="mb-3">
                    {/* <FormControl as="select" aria-describedby="custom-addons1" className="custom-select" value={states?.category_slug || states?.category || ""} name='category' onChange={handleChange}> */}
                    <FormControl as="select" aria-describedby="custom-addons1" className="custom-select" value={states?.sub_type || ""}
                      name='sub_type' onChange={handleProductSubType}>
                      <option value={""} disabled>Choose sub type</option>
                      {subCategoryData?.map((item, index) => <option value={item?.slug} className='text-capitalize'>{item?.name}</option>)}
                    </FormControl>
                  </InputGroup>
                </Col>
              }

              {Boolean(categoryData?.length) &&
                <Col lg={6}>
                  <Form.Label column sm={3}>
                    Category
                  </Form.Label>

                  <Select
                    value={states?.category}
                    // defaultValue={states?.category}
                    // onChange={setSelectCategory}
                    onChange={(selectCategory) => handleCategoryChange(selectCategory)}
                    options={categoryData}
                    isMulti="true"
                    name="category"
                  />
                </Col>
              }
            </Form.Group>

            <Form>
              <Form.Group className="mb-1 align-items-end mt-3" as={Row}>
                <Col lg={5}>
                  <Form.Label className='d-block mb-0 text-black fw-bolder'>Information</Form.Label>
                </Col>
                <Select
                  value={selectedInformation}
                  onChange={setSelectedInformation}
                  options={informationData}
                  isMulti
                  name="category"
                />
              </Form.Group>

              {selectedInformation.length > 0 && selectedInformation.map(info => (
                <div key={info.value}>
                  <h6 className='mt-4'>{info.label}</h6>
                  {Boolean(info?.label === "Engagement Ring Details") &&
                    <Form.Group className="mb-3" as={Row}>
                      <Form.Label column sm={3}>Center Diamond Shape</Form.Label>
                      <Select
                        value={centerDiamondShape}
                        onChange={setCenterDiamondShape}
                        options={shapeData}
                        isMulti
                        name="Center Diamond"
                      />
                    </Form.Group>
                  }
                  {titles[info.value]?.map((titleObj, titleIndex) => (
                    <div className='card rounded-3  p-3' key={titleIndex}>
                      <Form.Group className="mb-2">
                        <Row className='align-items-start'>
                          <Col lg={6} className='order-2 order-lg-1'>
                            <Form.Label column sm={3}>Title</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter title"
                              value={titleObj.title}
                              onChange={(e) => handleTitleChange(info.value, titleIndex, e)}
                            />
                          </Col>
                          <Col lg={6} className='order-1 order-lg-2'>
                            <div className='d-flex justify-content-end gap-3'>
                              {titles[info.value].length - 1 === titleIndex
                                &&
                                <i
                                  className="feather icon-plus plush-box"
                                  style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                                  onClick={() => handleAddTitle(info.value)}
                                />
                              }
                              {titles[info.value].length - 1 !== titleIndex && (
                                <i
                                  className="feather icon-trash trash-box bg-danger"
                                  style={{ fontSize: 'xx-large', cursor: 'pointer', color: 'red' }}
                                  onClick={() => handleDeleteTitle(info.value, titleIndex)}
                                />
                              )}

                            </div>
                          </Col>

                        </Row>
                      </Form.Group>


                      <Form.Group as={Row} className='mb-2 g-2'>
                        <Col lg={6}>
                          <Form.Label column sm={6}>Key</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter key"
                            value={titleObj.currentKeyInfo || ''} // Get current key for this title
                            onChange={(e) => handleKeyChange(info.value, titleIndex, e.target.value)}
                          />
                        </Col>
                        <Col lg={6}>
                          <Form.Label column sm={6}>Value</Form.Label>
                          <div className='d-flex align-items-center gap-2'>
                            <Form.Control
                              type="text"
                              placeholder="Enter Value"
                              value={titleObj.currentValueInfo || ''} // Get current value for this title
                              onChange={(e) => handleValueChange(info.value, titleIndex, e.target.value)}
                            />
                            <i
                              className="feather icon-plus plush-box"
                              style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                              onClick={() => handleAddRowInfo(info.value, titleIndex)}
                            />
                          </div>

                        </Col>
                        <Col sm={2} className='mb-1'>

                        </Col>
                      </Form.Group>

                      {titleObj.keyValues.map((keyValue, keyValueIndex) => (
                        <Form.Group className="mb-3 align-items-end g-2" as={Row} key={keyValueIndex}>
                          <Col lg={6}>
                            <Form.Control type="text" placeholder="Key" value={keyValue.key} disabled />
                          </Col>
                          <Col lg={6}>
                            <div className='d-flex align-items-center gap-2'>
                              <Form.Control type="text" placeholder="Value" value={keyValue.value} disabled />
                              <i
                                className="feather icon-trash trash-box bg-danger"
                                style={{ fontSize: 'xx-large', cursor: 'pointer', color: 'red' }}
                                onClick={() => handleDeleteRowInfo(info.value, titleIndex, keyValueIndex)}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      ))}
                    </div>
                  ))}
                  <hr />
                  {/* <Col sm={2} className='mb-1'>
                            <i
                                className="feather icon-plus"
                                style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                                onClick={() => handleAddTitle(info.value)}
                            />
                        </Col> */}
                </div>
              ))}
              {/* <Button onClick={formatData} variant="primary">Submit</Button> */}
            </Form>

            {/* <Form.Group className="mb-1 align-items-end mt-3" as={Row} controlId="formHorizontalName">
              <Col lg={5}>
                <Form.Label className='d-block mb-0 text-black fw-bolder'>
                  Information
                </Form.Label>
                <Form.Label column sm={6}>Key</Form.Label>
                <Form.Control type="text" placeholder="Enter key" value={keyInfo || ""} onChange={(e) => setKeyInfo(e?.target?.value)} />
              </Col>
              <Col lg={5}>
                <Form.Label column sm={6}>Value</Form.Label>
                <Form.Control type="text" placeholder="Enter Value" value={valueInfo || ""} onChange={(e) => setValueInfo(e?.target?.value)} />
              </Col>
              <Col sm={2} className='mb-1'>
                <i className="feather icon-plus" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={handleAddRowInfo} />
              </Col>
            </Form.Group>
            {states?.information?.length > 0 && states?.information?.map((row, index) => (
              <Form.Group className="mb-1 align-items-end" as={Row} controlId="formHorizontalName">
                <Col lg={5}>
                  <Form.Control type="text" placeholder="Value" value={row?.key} disabled />
                </Col>
                <Col lg={5}>
                  <Form.Control type="text" placeholder="Value" value={row?.value} disabled />
                </Col>
                <Col sm={2} className='mb-1'>
                  <i className="feather icon-trash" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={() => handleDeleteRowInfo(index)} />
                </Col>
              </Form.Group>
            ))} */}

            <Form.Group as={Row} controlId="formHorizontalDisplayName">
              <Col lg={4}>
                <Form.Label column sm={3}>
                  Select metal
                </Form.Label>
                <Select
                  // defaultValue={selectedMetals}
                  value={selectedMetals}
                  // onChange={setSelectedMetals}
                  onChange={(selectCategory) => handleMetalChange(selectCategory)}
                  options={metalData}
                  isMulti={true}
                />
              </Col>
            </Form.Group>

            <Form.Group className="mb-3 mt-0 g-2" as={Row} controlId="formHorizontalDisplayName">
              {Boolean(states?.metal?.length) && states.metal.map((metal, index) => {

                // const is_data = states?.metal?.find((v)=>v.metal_id === metal.value) || {}
                // const is_engrave = is_data?.is_engrave || false; 
                // const engrave_image = is_data?.engrave_image || null;
                const horizontal_image = metal?.metal_photos?.find((v) => v.key === 'top')?.image || null
                const vertical_image = metal?.metal_photos?.find((v) => v.key === 'side1')?.image || null
                const extra_image = metal?.metal_photos?.find((v) => v.key === 'extra')?.image || []
                const h_id = metal?.metal_photos?.find((v) => v.key === 'top')?.image_id || null
                const v_id = metal?.metal_photos?.find((v) => v.key === 'side1')?.image_id || null

                return <Col xs={12} key={index}>
                  <Form.Label column sm={12} className='text-black pb-0 fw-bolder text-capitalize'>
                    {metal?.metal_name} {" Metal Images"}
                  </Form.Label>
                  <div className='d-flex align-items-center gap-3 profile-image-upload-box'>

                    {((Boolean(metal?.metal_shape?.length) &&
                      (metal.metal_shape.length === 1 && editMode?.includes(metal.metal_shape[0]?.shape_id))) || !Boolean(metal?.metal_shape?.length)) &&
                      <>
                        <div>
                          <Form.Label column>{'Horizontal Image'}</Form.Label>
                          <div className='d-flex align-items-center gap-3 flex-wrap'>
                            <div className="position-relative profile-image" id="profile_image">
                              <div className="d-flex flex-wrap position-relative">
                                {
                                  horizontal_image &&
                                  <>
                                    <img
                                      src={horizontal_image?.size ? URL.createObjectURL(horizontal_image) : horizontal_image}
                                      onClick={() => handleImageClick(metal.metal_id, '', "Horizontal Image")}
                                      className={`cursor-pointer upload-image`}
                                      // alt={`horizontal image`}
                                      style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
                                    />
                                    <i className="feather icon-trash position-absolute" style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                                      onClick={() => {
                                        setDeleteFun({ metalSlug: metal.metal_id, imageType: "Horizontal Image", id: h_id ? h_id : "" })
                                        setDeleteModal(true);
                                        // setDeleteFun(() => () => handleDeleteImageData(id, "Horizontal Image"));
                                        // setDeleteFun(() => {
                                        //   if (h_id) {
                                        //     setRemoveImageList((prev) => [...prev, h_id]);
                                        //   }
                                        //   handleDeleteImageData(metal.metal_id, "Horizontal Image");
                                        // });
                                      }}
                                    />
                                  </>
                                }
                              </div>

                              <input
                                type="file"
                                accept=".jpg, .jpeg, .png, webm, .webp"
                                style={{ display: "none" }}
                                ref={el => fileInputRefs.current[`${metal.metal_id}-${''}-${"Horizontal Image"}`] = el}
                                onChange={(e) => handleImageChange(e, metal.metal_id, "Horizontal Image")}
                              />
                              {
                                !horizontal_image &&
                                <img
                                  src={camera}
                                  onClick={() => handleImageClick(metal.metal_id, '', "Horizontal Image")}
                                  className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                                  width={30}
                                  height={30} />
                              }
                            </div>
                          </div>
                        </div>

                        <div>
                          <Form.Label column>{'Vertical Image'}</Form.Label>
                          <div className='d-flex align-items-center gap-3 flex-wrap'>
                            <div className="position-relative profile-image" id="profile_image">
                              <div className="d-flex flex-wrap position-relative">
                                {
                                  vertical_image &&
                                  <>
                                    <img
                                      src={vertical_image?.size ? URL.createObjectURL(vertical_image) : vertical_image}
                                      onClick={() => {
                                        handleImageClick(metal.metal_id, '', "Vertical Image")
                                      }
                                      }
                                      className={`cursor-pointer upload-image`}
                                      // alt={`horizontal image`}
                                      style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
                                    />
                                    <i className="feather icon-trash position-absolute" style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                                      onClick={() => {
                                        setDeleteFun({ metalSlug: metal.metal_id, imageType: "Vertical Image", id: v_id ? v_id : "" })
                                        setDeleteModal(true);
                                      }}
                                    // onClick={() => {
                                    //   if (v_id) {
                                    //     setRemoveImageList((prev) => [...prev, v_id]);
                                    //   }
                                    //   handleDeleteImageData(metal.metal_id, "Vertical Image")
                                    // }}
                                    />
                                  </>
                                }
                              </div>

                              <input
                                type="file"
                                accept=".jpg, .jpeg, .png, webm, .webp"
                                style={{ display: "none" }}
                                ref={el => fileInputRefs.current[`${metal.metal_id}-${''}-${"Vertical Image"}`] = el}
                                onChange={(e) => handleImageChange(e, metal.metal_id, "Vertical Image")}
                              />
                              {
                                !vertical_image &&
                                <img
                                  src={camera}
                                  onClick={() => handleImageClick(metal.metal_id, '', "Vertical Image")}
                                  className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                                  width={30}
                                  height={30} />
                              }
                            </div>
                          </div>
                        </div>

                        {/* {renderImageUpload(metal.value, '', 'top', 'Horizontal Image')} */}
                        {/* {renderImageUpload(metal.metal_id, '', 'side1', 'Vertical Image')} */}
                      </>}

                    <div>
                      <Form.Label column>{'Extra Images'}</Form.Label>
                      <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <div className="position-relative profile-image" id="profile_image">
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png, webm, .webp"
                            style={{ display: "none" }}
                            multiple
                            ref={el => fileInputRefs.current[`${metal.metal_id}-${''}-${"Extra Images"}`] = el}
                            onChange={(e) => handleImageChange(e, metal?.metal_id, "Extra Images")}
                          />
                          <img
                            src={camera}
                            onClick={() => handleImageClick(metal?.metal_id, '', "Extra Images")}
                            className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                            width={30}
                            height={30} />
                        </div>
                        {Array.isArray(extra_image) && extra_image?.map((image, index) =>
                          <div className="d-flex flex-wrap position-relative">
                            <img
                              src={image?.size ? URL.createObjectURL(image) : image?.image ? image?.image : image}
                              onClick={() => handleImageClick(metal.metal_id, '', "Extra Images")}
                              // className={`cursor-pointer upload-image`}
                              className={`cursor-pointer upload-image border rounded-3`}
                              // alt={`horizontal image`}
                              // style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
                              style={{ width: '100px', height: '100px', objectFit: 'contain', }}
                            />
                            {
                              image && <i className="feather icon-trash position-absolute" style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                                onClick={() => {
                                  // handleDeleteImageData(metal.metal_id, "Extra Images", index)
                                  setDeleteFun({ metalSlug: metal.metal_id, imageType: "Extra Images", id: image?.image_id ? image?.image_id : "", index: index })
                                  setDeleteModal(true);
                                }}

                              // onClick={() => {
                              //     if (image?.image_id) {
                              //       setRemoveImageList((prev) => [...prev, image?.image_id]);
                              //     }
                              //     handleDeleteImageData(metal.metal_id, "Extra Images", index)
                              //   }}
                              />
                            }
                          </div>

                        )}
                      </div>
                    </div>

                    {/* {renderImageUpload(metal.metal_id, '', 'extra', 'Extra Images')} */}
                  </div>

                  <Form.Group as={Row} controlId="formHorizontalCheck">
                    <Form.Label as="legend" column lg={1} className='mb-0'>
                      Is Engrave
                    </Form.Label>
                    <Col sm={9}>
                      <Form.Check label="True" name="is_engrave" checked={metal?.is_engrave || false} onChange={(e) => handleEngraveStatusChange(metal?.metal_id, e?.target?.checked)} style={{ paddingBlock: "7px" }} />
                    </Col>
                  </Form.Group>

                  {metal?.is_engrave && renderEngraveImageInput(metal.metal_id, "engrave", metal?.engrave_image)}

                  Copy code
                  <Form.Group as={Row} controlId="formHorizontalPrice">
                    <Form.Label as="legend" column lg={1} className='mb-3'>
                      Price
                    </Form.Label>
                    <Col sm={3}>
                      <Form.Control
                        type="number"
                        name="price"
                        value={metal?.price || ''}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (!value || /^[0-9]*\.?[0-9]*$/.test(value)) {
                            handlePrice(metal?.metal_id, value);
                          }
                        }}
                        className="no-spinner" // Custom class to hide spinners
                        onWheel={(e) => e.currentTarget.blur()} // Prevent increment/decrement on scroll
                        style={{ paddingBlock: "7px" }}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formHorizontalDiscount">
                    <Form.Label as="legend" column lg={1} className='mb-3'>
                      Discount (%)
                    </Form.Label>
                    <Col sm={3}>
                      <Form.Control
                        type="number"
                        name="discount"
                        value={metal?.discount || ''}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (!value || /^[0-9]*\.?[0-9]*$/.test(value)) {
                            handleDiscount(metal?.metal_id, value);
                          }
                        }}
                        className="no-spinner" // Custom class to hide spinners
                        onWheel={(e) => e.currentTarget.blur()} // Prevent increment/decrement on scroll
                        style={{ paddingBlock: "7px" }}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group className="mb-4" as={Row} controlId="formHorizontalDisplayName">
                    <Col lg={4}>
                      <Form.Label column sm={5}>
                        Select {metal?.metal_name} {" Metal "} Shape
                      </Form.Label>
                      <Select
                        value={selectedShapes[metal.metal_id]}
                        onChange={(selectedOptions) => handleShapeChange(selectedOptions, metal.metal_id)}
                        options={shapeData}
                        isMulti={true}
                      />
                    </Col>
                    {Boolean(metal?.metal_shape?.length) && metal?.metal_shape?.map((shapeItem) => {
                      const horizontal_image = shapeItem?.image?.find((v) => v.key === 'top')?.image || null
                      const vertical_image = shapeItem?.image?.find((v) => v.key === 'side1')?.image || null
                      const h_id = shapeItem?.image?.find((v) => v.key === 'top')?.image_id || null
                      const v_id = shapeItem?.image?.find((v) => v.key === 'side1')?.image_id || null

                      if (!editMode?.includes(shapeItem.shape_id))
                        return <Col xs={12} key={shapeItem.shape_id}>
                          <Form.Label column sm={12} className='text-black pb-0 fw-bolder text-capitalize'>
                            {shapeItem?.shape || shapeItem?.shape_id} {" Shape Images"}
                          </Form.Label>
                          <div className='d-flex align-items-center gap-3 profile-image-upload-box'>

                            <div>
                              <Form.Label column>{'Horizontal Image'}</Form.Label>
                              <div className='d-flex align-items-center gap-3 flex-wrap'>
                                <div className="position-relative profile-image" id="profile_image">
                                  <div className="d-flex flex-wrap position-relative">
                                    {
                                      horizontal_image &&
                                      <>
                                        <img
                                          src={horizontal_image?.size ? URL.createObjectURL(horizontal_image) : horizontal_image}
                                          onClick={() => handleImageClick(metal.metal_id, shapeItem.shape_id, "Horizontal Image")}
                                          className={`cursor-pointer upload-image`}
                                          // alt={`horizontal image`}
                                          style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
                                        />
                                        <i className="feather icon-trash position-absolute" style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                                          onClick={() => {

                                            setDeleteFun({ metalSlug: metal.metal_id, shapeSlug: shapeItem.shape_id, imageType: "Horizontal Image", id: h_id ? h_id : "" })
                                            setDeleteModal(true);
                                          }}
                                        // onClick={() => {
                                        //     if (h_id) {
                                        //       setRemoveImageList((prev) => [...prev, h_id]);
                                        //     }
                                        //     handleDeleteShapeImageData(metal.metal_id, shapeItem.shape_id, "Horizontal Image")
                                        //   }} 
                                        />
                                      </>
                                    }
                                  </div>

                                  <input
                                    type="file"
                                    accept=".jpg, .jpeg, .png, webm, .webp"
                                    style={{ display: "none" }}
                                    ref={el => fileInputRefs.current[`${metal.metal_id}-${shapeItem.shape_id}-${"Horizontal Image"}`] = el}
                                    onChange={(e) => handleShapeImageChange(e, metal.metal_id, shapeItem.shape_id, "Horizontal Image")}
                                  />
                                  {
                                    !horizontal_image &&
                                    <img
                                      src={camera}
                                      onClick={() => handleImageClick(metal.metal_id, shapeItem.shape_id, "Horizontal Image")}
                                      className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                                      width={30}
                                      height={30} />
                                  }
                                </div>
                              </div>
                            </div>

                            <div>
                              <Form.Label column>{'Vertical Image'}</Form.Label>
                              <div className='d-flex align-items-center gap-3 flex-wrap'>
                                <div className="position-relative profile-image" id="profile_image">
                                  <div className="d-flex flex-wrap position-relative">
                                    {
                                      vertical_image &&
                                      <>
                                        <img
                                          src={vertical_image?.size ? URL.createObjectURL(vertical_image) : vertical_image}
                                          onClick={() => handleImageClick(metal.metal_id, shapeItem.shape_id, "Vertical Image")}
                                          className={`cursor-pointer upload-image`}
                                          // alt={`horizontal image`}
                                          style={{ width: '100px', height: '100px', objectFit: 'contain', marginRight: '10px' }}
                                        />
                                        <i className="feather icon-trash position-absolute" style={{ fontSize: 'xx-large', cursor: 'pointer' }}
                                          onClick={() => {
                                            setDeleteFun({ metalSlug: metal.metal_id, shapeSlug: shapeItem.shape_id, imageType: "Vertical Image", id: v_id ? v_id : "" })
                                            setDeleteModal(true);
                                          }}
                                        // onClick={() => handleDeleteShapeImageData(metal.metal_id, shapeItem.shape_id, "Vertical Image")} 
                                        />
                                      </>
                                    }
                                  </div>

                                  <input
                                    type="file"
                                    accept=".jpg, .jpeg, .png, webm, .webp"
                                    style={{ display: "none" }}
                                    ref={el => fileInputRefs.current[`${metal.metal_id}-${shapeItem.shape_id}-${"Vertical Image"}`] = el}
                                    onChange={(e) => handleShapeImageChange(e, metal.metal_id, shapeItem.shape_id, "Vertical Image")}
                                  />
                                  {
                                    !vertical_image &&
                                    <img
                                      src={camera}
                                      onClick={() => handleImageClick(metal.metal_id, shapeItem.shape_id, "Vertical Image")}
                                      className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                                      width={30}
                                      height={30} />
                                  }
                                </div>
                              </div>
                            </div>
                            {/* {renderImageUpload(metal.shape_id, shapeItem.shape_id, 'top', 'Horizontal Image')}
                          {renderImageUpload(metal.shape_id, shapeItem.shape_id, 'side1', 'Vertical Image')} */}
                          </div>
                        </Col>
                    })}
                  </Form.Group>
                </Col>
              })}
            </Form.Group>

            {/* <Form.Group className="mb-1 align-items-end mt-3" as={Row} controlId="formHorizontalName">
              <Col lg={5}>
                <Form.Label className='d-block mb-0 text-black fw-bolder'>
                  Gemstone
                </Form.Label>
                <Form.Control type="text" placeholder="Enter current gemstone name" name="gemstone_name" value={states?.gemstone_name || ""} onChange={handleChange} />
                <Form.Label column sm={6}>Name</Form.Label>
                <Form.Control type="text" placeholder="Enter gemstone name" value={gName || ""} onChange={(e) => setGName(e?.target?.value)} />
              </Col>
              <Col lg={5}>
                <Form.Label column sm={6}>Select Product Name</Form.Label>
                <Select
                  value={gpSelect}
                  defaultValue={gpSelect}
                  onChange={setGPSelect}
                  options={productList}
                  placeholder={"Select product name"}
                />
              </Col>
              <Col sm={2}>
                <i className="feather icon-plus" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={handleAddRowGemstone} />
              </Col>
            </Form.Group>
            {rowsGemstone?.map((row, index) => (
              <Form.Group className="mb-1 align-items-end" as={Row} controlId="formHorizontalName">
                <Col lg={1}>
                  <Form.Control type="text" placeholder="Value" value={row?.index || ""}
                    onBlur={(e) => gemstoneIndexChange(index, e.target.value - 1)}
                    onChange={(e) => {
                      const updatedRows = [...rowsGemstone];
                      updatedRows[index] = { ...updatedRows[index], index: e.target.value };
                      setRowsGemstone(updatedRows);
                    }}
                  />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.name} disabled />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.product} disabled />
                </Col>
                <Col sm={2}>
                  <i className="feather icon-trash" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={() => handleDeleteGemstone(index)} />
                </Col>
              </Form.Group>
            ))} */}

            {/* <Form.Group className="mb-1 align-items-end mt-3" as={Row} controlId="formHorizontalName">
              <Col lg={5}>
                <Form.Label className='d-block mb-0 text-black fw-bolder'>
                  Carat
                </Form.Label>
                <Form.Control type="text" placeholder="Enter current carat name" name="carat_name" value={states?.carat_name || ""} onChange={handleChange} />
                <Form.Label column sm={6}>Name</Form.Label>
                <Form.Control type="text" placeholder="Enter carat name" value={cName || ""} onChange={(e) => setCName(e?.target?.value)} />
              </Col>
              <Col lg={5}>
                <Form.Label column sm={6}>Select Product Name</Form.Label>
                <Select
                  value={cpSelect}
                  defaultValue={cpSelect}
                  onChange={setCPSelect}
                  options={productList}
                  placeholder={"Select product name"}
                />
              </Col>
              <Col sm={2}>
                <i className="feather icon-plus" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={handleAddRowCarat} />
              </Col>
            </Form.Group>
            {rowsCarat?.map((row, index) => (
              <Form.Group className="mb-1 align-items-end" as={Row} controlId="formHorizontalName">
                <Col lg={1}>
                  <Form.Control type="text" placeholder="Value" value={row?.index || ""}
                    onBlur={(e) => caratIndexChange(index, e.target.value - 1)}
                    onChange={(e) => {
                      const updatedRows = [...rowsCarat];
                      updatedRows[index] = { ...updatedRows[index], index: e.target.value };
                      setRowsCarat(updatedRows);
                    }}
                  />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.name} disabled />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.product} disabled />
                </Col>
                <Col sm={2}>
                  <i className="feather icon-trash" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={() => handleDeleteCarat(index)} />
                </Col>
              </Form.Group>
            ))} */}

            {/* <Form.Group className="mb-1 align-items-end mt-3" as={Row} controlId="formHorizontalName">
              <Col lg={5}>
                <Form.Label className='d-block mb-0 text-black fw-bolder'>
                  Length
                </Form.Label>
                <Form.Control type="text" placeholder="Enter current length name" name="length_name" value={states?.length_name || ""} onChange={handleChange} />
                <Form.Label column sm={6}>Name</Form.Label>
                <Form.Control type="text" placeholder="Enter length value" value={lName || ""} onChange={(e) => setLName(e?.target?.value)} />
              </Col>
              <Col lg={5}>
                <Form.Label column sm={6}>Select Product Name</Form.Label>
                <Select
                  value={lpSelect}
                  defaultValue={lpSelect}
                  onChange={setLPSelect}
                  options={productList}
                  placeholder={"Select product name"}
                />
              </Col>
              <Col sm={2}>
                <i className="feather icon-plus" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={handleAddRowLength} />
              </Col>
            </Form.Group>
            {rowsLength?.map((row, index) => (
              <Form.Group className="mb-1 align-items-end" as={Row} controlId="formHorizontalName">
                <Col lg={1}>
                  <Form.Control type="text" placeholder="Value" value={row?.index || ""}
                    onBlur={(e) => lengthIndexChange(index, e.target.value - 1)}
                    onChange={(e) => {
                      const updatedRows = [...rowsLength];
                      updatedRows[index] = { ...updatedRows[index], index: e.target.value };
                      setRowsLength(updatedRows);
                    }}
                  />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.name} disabled />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.product} disabled />
                </Col>
                <Col sm={2}>
                  <i className="feather icon-trash" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={() => handleDeleteLength(index)} />
                </Col>
              </Form.Group>
            ))}

            <Form.Group className="mb-1 align-items-end mt-3" as={Row} controlId="formHorizontalName">
              <Col lg={5}>
                <Form.Label className='d-block mb-0 text-black fw-bolder'>
                  Size
                </Form.Label>
                <Form.Control type="text" placeholder="Enter current size name" name="size_name" value={states?.size_name || ""} onChange={handleChange} />
                <Form.Label column sm={6}>Name</Form.Label>
                <Form.Control type="text" placeholder="Enter size name" value={sName || ""} onChange={(e) => setSName(e?.target?.value)} />
              </Col>
              <Col lg={5}>
                <Form.Label column sm={6}>Select Product Name</Form.Label>
                <Select
                  value={spSelect}
                  defaultValue={spSelect}
                  onChange={setSPSelect}
                  options={productList}
                  placeholder={"Select product name"}
                />
              </Col>
              <Col sm={2}>
                <i className="feather icon-plus" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={handleAddRowSize} />
              </Col>
            </Form.Group>
            {rowsSize?.map((row, index) => (
              <Form.Group className="mb-1 align-items-end" as={Row} controlId="formHorizontalName">
                <Col lg={1}>
                  <Form.Control type="text" placeholder="Value" value={row?.index || ""}
                    onBlur={(e) => sizeIndexChange(index, e.target.value - 1)}
                    onChange={(e) => {
                      const updatedRows = [...rowsSize];
                      updatedRows[index] = { ...updatedRows[index], index: e.target.value };
                      setRowsSize(updatedRows);
                    }}
                  />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.name} disabled />
                </Col>
                <Col lg={4}>
                  <Form.Control type="text" placeholder="Value" value={row?.product} disabled />
                </Col>
                <Col sm={2}>
                  <i className="feather icon-trash" style={{ fontSize: 'xx-large', cursor: 'pointer' }} onClick={() => handleDeleteSize(index)} />
                </Col>
              </Form.Group>
            ))} */}

            {/* <div className='row mt-3'>
              <div className='col-2'>
                <Form.Group className='d-flex align-items-center gap-3' controlId="formHorizontalCheck1">
                  <Form.Label as="legend" className='col-form-label'>
                    Is Diamond
                  </Form.Label>
                  <Form.Check  className='checkbox-label' label="True" name="is_diamond" onClick={handleChange} />
                </Form.Group>
              </div>
            </div> */}

            <Form.Group as={Row} controlId="formHorizontalCheck">
              <Form.Label as="legend" column lg={1}>
                Is Diamond
              </Form.Label>
              <Col sm={9}>
                <Form.Check label="True" name="is_diamond" checked={states?.is_diamond} onClick={handleChange} style={{ paddingBlock: "7px" }} />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalCheck">
              <Form.Label as="legend" column lg={1} className='mb-0' >
                Is Active
              </Form.Label>
              <Col sm={9}>
                <Form.Check label="True" name="is_activate" checked={states?.is_activate} onClick={handleChange} style={{ paddingBlock: "7px" }} />
              </Col>
            </Form.Group>

            {/* <Form.Group as={Row} controlId="formHorizontalCheck">
              <Form.Label as="legend" column lg={1} className='mb-0'>
                Is Engrave
              </Form.Label>
              <Col sm={9}>
                <Form.Check label="True" name="is_engrave" onClick={handleChange} style={{ paddingBlock: "7px" }} />
              </Col>
            </Form.Group>

            {Boolean(states?.is_engrave) &&
              <Form.Group className="mb-3 d-flex align-items-center" as={Row} controlId="formHorizontalCheck">
                <Form.Label as="legend" column lg={1} className='mb-0'>
                  Engrave Image
                </Form.Label>
                <div className="position-relative profile-image" id="profile_image">
                  <div className="d-flex">
                    {Boolean(states?.engrave_image) &&
                      <img
                        src={URL.createObjectURL(states?.engrave_image)}
                        onClick={handleEngClick}
                        className={`cursor-pointer upload-image`}
                      />
                    }
                  </div>
                  <input
                    type="file"
                    // accept="image/*"
                    accept=".jpg, .jpeg, .png, webm, .webp"
                    name="image"
                    style={{ display: "none" }}
                    ref={engRef}
                    onChange={handleEngImage}
                  />

                  <img
                    src={camera}
                    onClick={handleEngClick}
                    className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                    alt=""
                    width={30}
                    height={30}
                  />
                </div>
              </Form.Group>
            } */}

            <div className='d-flex justify-content-end'>
              <Button className='m-0' onClick={() => { handleSubmit() }}>Save</Button>
            </div>

          </Form>
        </Card.Body>
      </Card>

      {/* Delete */}
      <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
              <Card.Title as="h5">Delete {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body className='pb-2'>
              <h6>Are you sure you want to delete?</h6>
              <div className='d-flex justify-content-center'>
                <Button onClick={() => deleteImageFun()} className='mt-3 mb-0 mx-0'>Delete</Button>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddEditProductDetail